import React, { useEffect, useMemo, useState } from "react";

/**
 * A PDF already in hand (a POST answered it, e.g. /reports/batch_part_labels, which the print queue can't fetch) offered
 * from a tap: the share sheet (Print = AirPrint, Save to Files, AirDrop) inside the tap itself, as iPhone requires, or
 * Open in a new tab where files can't be shared. PdfButton's second step, for a blob. Layout only.
 */
export default function SharePdfBlob({ blob, filename = "document.pdf", label, testId = "share-pdf-blob" }) {
  const [shareError, setShareError] = useState(null);
  const file = useMemo(() => (blob ? new File([blob], filename, { type: "application/pdf" }) : null), [blob, filename]);
  const [href, setHref] = useState(null);

  useEffect(() => {
    if (!blob) return undefined;
    const url = URL.createObjectURL(blob);
    setHref(url);
    return () => URL.revokeObjectURL(url);
  }, [blob]);

  const canShare = Boolean(
    file && typeof navigator !== "undefined" && navigator.canShare && navigator.share && navigator.canShare({ files: [file] })
  );

  async function share() {
    setShareError(null);
    try {
      await navigator.share({ files: [file], title: label });
    } catch (err) {
      if (!err || err.name !== "AbortError") setShareError("The share sheet didn't open. Use Open instead.");
    }
  }

  if (!file) return null;
  return (
    <div className="mb-2" data-testid={testId}>
      {canShare && !shareError ? (
        <button type="button" className="btn btn-primary btn-lg w-100" onClick={share}>
          <i className="fas fa-share-square me-2" aria-hidden="true" />{label}: print or share
        </button>
      ) : (
        <a className="btn btn-primary btn-lg w-100" href={href || undefined} target="_blank" rel="noopener noreferrer">
          <i className="fas fa-file-pdf me-2" aria-hidden="true" />Open {label}
        </a>
      )}
      {shareError && <div className="text-danger small mt-1">{shareError}</div>}
    </div>
  );
}
